import { gql, DocumentNode } from '@apollo/client';
import { Avatar } from '@mui/material';
import React from 'react';
import getInitials from '../../lib/helpers/getInitials';
import { Tooltip, TooltipProps } from '../../blocks/Tooltip';
import { ContactCustomerAvatarContactFragment } from '#types';
import rpcShared from '@rockpapercoin/rpc-shared';

const contactCustomerAvatarContactFragment = gql`
	fragment contactCustomerAvatarContact on Contact {
		id
		firstName
		lastName
		status
		hasCustomerIntent
		customer {
			id
			email
			clientUser {
				id
				updatedAt
			}
			orgUser {
				id
				updatedAt
			}
		}
	}
`;

export type ContactCustomerAvatarProps = {
	contact: ContactCustomerAvatarContactFragment;
	className?: string;
	dataCy?: string;
} & Pick<TooltipProps, 'disablePortal'>;

type ContactCustomerAvatarPropsWithFragment =
	React.FC<ContactCustomerAvatarProps> & {
		fragments: {
			contactCustomerAvatarContactFragment: DocumentNode;
		};
	};

const ContactCustomerAvatar: ContactCustomerAvatarPropsWithFragment = ( {
	contact,
	className,
	dataCy = 'contact-customer-avatar',
	disablePortal,
} ) => (
	<Tooltip
		disablePortal={ disablePortal }
		target={
			<Avatar src={ undefined } className={ className } data-cy={ dataCy }>
				{ getInitials( contact ) }
			</Avatar>
		}
	>
		{ rpcShared.contacts.getCustomerName( contact ).fullName }
	</Tooltip>
);

ContactCustomerAvatar.fragments = {
	contactCustomerAvatarContactFragment,
};

export default ContactCustomerAvatar;
